<template>
    <div class="template-card">
        <iframe
            class="template-preview"
            ref="iframe"
            v-bind:src="previewUrl"
        >
        </iframe>
    </div>
</template>

<script>
    import dmVisualizerApi from '../../../../Api/dm-visualizer'
    
    export default {
        name: "scenario-templates",
        props: ['id'],
        computed: {
            previewUrl(){
                return dmVisualizerApi.formatTemplatePreviewUrl(this.id);
            }
        }
    }
</script>

<style scoped src="../../Style/scenario-template-item.scss" lang="scss">
    
</style>
